// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__L4TkU","savePackageButton":"ClientWallet_savePackageButton__1tZR3"};